module.exports = __webpack_public_path__ + "static/media/img_bg.6ff81f80.png";